import React, { useContext } from "react";
import "./CertificatesHome.css";
import "./ResponsiveCer.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Autoplay, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Button } from "react-bootstrap";
import { json, useNavigate } from "react-router-dom";
import { dataContext } from "../../context/DataContextProviderr";


const CertificatesHome = () => {
  const { allProducts } = useContext(dataContext);
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  return (
    <div className="cer-home">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 250000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper"
      >
        {allProducts &&
          allProducts
            ?.filter((f) => f.summary === "certificates")
            ?.map((item, index) => {
              const downloadLink = JSON.parse(item?.shopLink)[0]?.Url;
              return (
                <SwiperSlide key={index}>
                  <div className="left">
                    <div className="logo">
                      <img src="/pic/logo.png" alt="logo" />
                      <p>گواهینامه ها</p>
                    </div>
                    <div className="subject">
                      <p>گواهینامه ها، استانداردها و جوایز گروه آرد زر</p>
                    </div>
                    <div className="title">
                      <p>{item.title}</p>
                    </div>
                    <div className="description">
                      <p>
                        {
                          JSON.parse(item?.specification)?.filter(
                            (f) => f.Key === "description"
                          )[0]?.Value
                        }
                      </p>
                    </div>
                    <div className="button-container">
                      <Button onClick={() => navigateHandler("/certificates")}>
                        مشاهده بیشتر
                      </Button>
                      <div className="button-container2">
                        <a target="_blank" rel='noreferrer' href={downloadLink}>
                          <Button>دانلود</Button>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="logo">
                      <img src="/pic/logo.png" alt="logo" />
                      <p>گواهینامه ها</p>
                    </div>
                    <div className="subject">
                      <p>گواهینامه ها، استانداردها و جوایز گروه آرد زر</p>
                    </div>
                    <img
                      className="img"
                      src={`${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=0&imageName=${item.image}`}
                      alt="certificate-pic"
                    />
                  </div>
                </SwiperSlide>
              );
            })}
      </Swiper>
    </div>
  );
};

export default CertificatesHome;
